import React from 'react';
import { Box, ButtonBase } from '@mui/material';
import { Inventory2Outlined, BuildOutlined } from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';
import ProductBackupList from '../products/ProductBackupList';
import ToolBackupList from './ToolBackupList';

const TABS = [
  { key: 'products', label: 'Products', icon: <Inventory2Outlined sx={{ fontSize: 19 }} /> },
  { key: 'tools', label: 'Tools', icon: <BuildOutlined sx={{ fontSize: 19 }} /> },
];

// Backup page: product backups and website tool backups, one tab each
const BackupHome = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') === 'tools' ? 'tools' : 'products';

  return (
    <Box sx={{ maxWidth: 1600, mx: 'auto' }}>
      <Box sx={{ display: 'inline-flex', gap: 0.5, p: 0.5, mb: 3, borderRadius: '10px', background: '#F2F4F7', border: '1px solid #EAECF0' }}>
        {TABS.map((t) => {
          const active = t.key === tab;
          return (
            <ButtonBase
              key={t.key}
              onClick={() => setSearchParams(t.key === 'products' ? {} : { tab: t.key })}
              sx={{
                display: 'flex', alignItems: 'center', gap: 1, px: 2.25, py: 1, borderRadius: '8px',
                fontSize: 14.5, fontWeight: 600,
                color: active ? '#512DA8' : '#667085',
                background: active ? '#fff' : 'transparent',
                boxShadow: active ? '0 1px 3px rgba(16, 24, 40, 0.1)' : 'none',
                '&:hover': { color: '#512DA8' },
              }}
            >
              {t.icon}
              {t.label}
            </ButtonBase>
          );
        })}
      </Box>
      {tab === 'tools' ? <ToolBackupList /> : <ProductBackupList />}
    </Box>
  );
};

export default BackupHome;
